@if (modal.visible) {
  <article class="point__container">
    <div class="point__backdrop">
      @if (hasWorkspaces && point) {
        <div class="point__animation">
          <pp-point-modal-header
            [ppAttachmentUploading]="attachmentUploading"
            [ppFull]="false"
            [ppPoint]="point"
            [ppPointId]="_id"
            [ppWorkspaceId]="workspaceId"
            [(ppPointDetails)]="pointDetails"
            (ppHide)="hide()"
            [ppNew]="false"
            [ppDetailsFetched]="detailsFetched"
            (ppUpdate)="generatePoint(point)"
          ></pp-point-modal-header>
          <pp-point-container
            [ppPointId]="point?._id"
            (click)="$event.stopPropagation()"
            (ppUpdateScrollPosition)="updateScrollPosition($event)"
          >
            <ng-container header>
              <header>
                <pp-point-action-bar
                  [ppPointId]="point?._id"
                  [ppWorkspaceId]="point?.workspaceRef.id"
                  [ppCanEdit]="canEditPoint"
                  [ppCanDelete]="canDeletePoint"
                  [ppUser]="user"
                  [ppScrollPosition]="scrollPosition"
                ></pp-point-action-bar>
              </header>
            </ng-container>
            <ng-container body>
              <section>
                @if (point) {
                  <pp-point-description
                    [ppPointId]="point?._id"
                    [ppWorkspaceId]="point?.workspaceRef.id"
                    [ppDescription]="point?.description"
                    [ppDescriptionRich]="point?.descriptionRich"
                    [ppCanEdit]="canEditPoint"
                  ></pp-point-description>
                }
              </section>
              @if (relatedPointsFlagEnabled && point?._id) {
                <section>
                  <pp-related-points
                    [ppRelationships]="point.relationships"
                    [ppWorkspaceId]="workspaceId"
                    [ppPointId]="point._id!"
                    [ppAccountId]="workspace.accountId"
                  ></pp-related-points>
                </section>
              }
              <section class="point__custom-fields">
                @if (point) {
                  <pp-point-fields
                    [ppPointId]="point?._id"
                    [ppWorkspaceId]="point?.workspaceRef.id"
                    [ppTags]="point?.tags"
                    [ppCanEdit]="canEditPoint"
                    [ppAssignees]="point?.assignees"
                  ></pp-point-fields>
                }
              </section>
              @defer (on idle) {
                <section>
                  @if (point) {
                    <pp-point-plan
                      [ppPointId]="point?._id"
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppCanEdit]="canEditPoint"
                      [ppWidth]="planWidth"
                    ></pp-point-plan>
                  }
                </section>
                <section>
                  @if (point) {
                    <pp-point-attachments
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="point?._id"
                      [ppCanEdit]="canEditPoint"
                    ></pp-point-attachments>
                  }
                </section>
                <section>
                  @if (point) {
                    <pp-point-activity
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="point?._id"
                      [ppCommentsEnabled]="commentsEditable && !!point"
                      [ppAttachmentUploading]="attachmentUploading"
                      [ppDetailsFetched]="freshPointFetched"
                    ></pp-point-activity>
                  }
                </section>
              }
            </ng-container>
            <ng-container footer>
              @if (commentsEditable && point) {
                @defer (on idle) {
                  <div
                    data-m-target="Point comment input field"
                    class="point__comment-input"
                    [class.point__comment-inputSpacing]="isTimeline || isOverview"
                  >
                    <pp-point-comment-input
                      [ppWorkspaceId]="point?.workspaceRef.id"
                      [ppPointId]="point?._id"
                    ></pp-point-comment-input>
                  </div>
                }
              }
            </ng-container>
          </pp-point-container>
        </div>
      }
    </div>
  </article>
}
